import { ScrollTrigger } from "gsap/ScrollTrigger";

// Find closest element
const getClosest = function (elem, selector) {
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
    }
    return null;
};

// Root selectors for caching
let _selectors = {
    accordion: ('.js-accordion'),
    title: ('.js-accordion-title'),
    content: ('.js-accordion-content')
};

// Module options
let _options = {
    oneActivePanel: true,
};

// Cached Elements.
let _el = {};

// Module Variables
let _vars = {};

// Module init
const _init = (options) => {
    // Extend options and update current ones
    _options = Object.assign({}, _options, options);

    // Define & Cache Elements
    _setElements();

    if (_vars.accordion) {
        _checkIfOpenAtFirst();
        _bindEvents();
    }
};

// Opens panel if there is a class of 'is-active' on the main accordion
const _checkIfOpenAtFirst = () => {
    _el.accordion.forEach((item) => {
        if (item.classList.contains('is-active')) {
            _openTargetPanel(item);
        }
    });
};

// Private functions
const _bindEvents = () => {

    // Attach only one click listener
    _el.title.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const accordion = getClosest(e.target, _selectors.accordion);

            if (accordion.classList.contains('is-active')) {
                _closeTargetPanel(accordion);
                ScrollTrigger.refresh();
            } else {
                if (_options.oneActivePanel) {
                    _closeAllPanels();
                }
                _openTargetPanel(accordion, true);
                ScrollTrigger.refresh();
            }
        });
    });
};

const _openTargetPanel = (accordion) => {
    const content = accordion.querySelectorAll(_selectors.content)[0];

    accordion.classList.add('is-active');
    content.style.height = content.scrollHeight + 'px';
};

const _closeTargetPanel = (accordion) => {
    const content = accordion.querySelectorAll(_selectors.content)[0];

    accordion.classList.remove('is-active');
    content.style.height = 0;
};

const _closeAllPanels = () => {
    _el.accordion.forEach((obj) => {
        obj.classList.remove('is-active');
    });

    _el.content.forEach((obj) => {
        obj.style.height = 0;
    });
};

// Set/Reset and Cache Module elements
const _setElements = () => {

    // Cache Elements into _el & create variable to check existence
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el;
        _vars[key] = el.length;
    });
};

const Accordion = {
    init: _init
};

export default Accordion;